import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MapsState } from './state';

const defaultState: MapsState = {
  clusters: [],
  scans: [],
};

export const mapsModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
